import { convertToObjById } from "helpers/convertToObject";

export const REQUEST_DATA_PG = "REQUEST_DATA_PG ";
export const GET_DATA_PG = "GET_DATA_PG";
export const EDIT_PG_MODE = "EDIT_PG_MODE";
export const DELETE_PG_MODE = "DELETE_PG_MODE"
export const ADD_PG_MODE = "ADD_PG_MODE";
export const RESET_PG_SELECTED= "RESET_PG_SELECTED";
export const RESET_PG_LOADING = "RESET_PG_LOADING";
export const CLEAR_PG = "CLEAR_PG";
export const CREATE_PG = "CREATE_PG";
export const EDIT_PG = "EDIT_PG";
export const DELETE_PG = "DELETE_PG";
export const PG_SELECTED = "PG_SELECTED";

const initialState ={
    loading: false,
    shipperTrucks: {},
    shipperTrucksArray: [],
    shipperTruckSelected: null,
    
    addshipperTruckMode: false,
    deleteshipperTrucksMode: false,
};
const toArray = (data) => {
    return Object.keys(data).map(id => {
      return data[id]
    })
  }
  const toObject = (data) => {
    return data.reduce((acc, curr) => {
      acc[curr.id || curr.id_unit] = curr
      return acc
    }, {})
  }
  export const shipperTrucksReducer = (state = initialState, action) => {
    const{type, payload} = action;
    switch (type){
        case REQUEST_DATA_PG:
            return {
                ...state,
                shipperTrucksArray: [],
                loading: true,
            }
        case GET_DATA_PG:
            return {
                ...state,
                shipperTrucks: toObject(payload),
                loading:false
                
            }
            case CREATE_PG:
                const dataArr = toArray(state.shipperTrucks)
                const addingShipperTruck = [action.payload, ...dataArr]
                const newShipperTruck = convertToObjById(addingShipperTruck)
                return {
                    ...state,
                    shipperTrucks: newShipperTruck,
                    shipperTrucksArray: addingShipperTruck,
                    loading: false
                }
            case EDIT_PG:
                return {
                    ...state,
                    shipperTrucks: {
                        ...state.shipperTrucks,
                        [action.payload.id]: {
                            ...state.shipperTrucks[action.payload.id],
                            ...action.payload
                        },
                    },
                    loading:false,
                }
            case DELETE_PG:
                const dataArray = toArray(state.shipperTrucks).filter(shipperTruck => shipperTruck.id !== action.payload)
                const shipperTruckDeleted = toObject(dataArray)
                return {
                    ...state,
                    shipperTrucks: shipperTruckDeleted,
                    shipperTrucksArray: dataArray,
                    loading: false
                }
            case ADD_PG_MODE:
                return {
                    ...state,
                    addshipperTruckMode: true,
                    deleteshipperTrucksMode: false                    
                }
            case DELETE_PG_MODE:
                return {
                    ...state,
                    addshipperTruckMode: false,
                    deleteshipperTrucksMode: true,
                }
            case EDIT_PG_MODE:
                return {
                    ...state,
                    addshipperTruckMode: false,
                    deleteshipperTrucksMode: false,
                }
            case PG_SELECTED:
                return {
                    ...state,
                    shipperTruckSelected: action.payload && state.shipperTrucks[action.payload]
                }

            case CLEAR_PG:
                return {
                    ...state,
                    ...initialState,
                }
            case RESET_PG_SELECTED:
                return {
                    ...state,
                    shipperTruckSelected: null
                }

        default:
            return state
    }
  }